import React from 'react';
import { DashboardModal } from 'containers/Dashboard/components/DashboardModal';
import __ from 'utils/i18n';

export const ReactivateSubscriptionModal = ({ 
  showModal = false, 
  hideModal, 
  subscriber, 
  submitAction, 
  submitDisabled = false 
}) => {
  if (!subscriber) return null;

  const customerName = subscriber.customer?.fullName || __('dashboard.sections.recurringPayments.subscribers.reactivateSubscriptionModal.defaultCustomer');
  const planName = subscriber.plan?.name || '-';

  return (
    <DashboardModal
      name="reactivateSubscriptionModal"
      headerText={__('dashboard.sections.recurringPayments.subscribers.reactivateSubscriptionModal.title')}
      showModal={showModal}
      hideModal={hideModal}
      submitAction={submitAction}
      submitColor="primary"
      submitDisabled={submitDisabled}
      hideSeparator={true}
      cancelText={__('dashboard.sections.recurringPayments.subscribers.reactivateSubscriptionModal.cancelButton')}
      submitText={submitDisabled 
        ? __('dashboard.sections.recurringPayments.subscribers.reactivateSubscriptionModal.reactivating')
        : __('dashboard.sections.recurringPayments.subscribers.reactivateSubscriptionModal.confirmButton')
      }
    >
      <div className="recurring-payments-text-wrap">
        <p className="mb-3">
          {__('dashboard.sections.recurringPayments.subscribers.reactivateSubscriptionModal.description', { 
            customerName, 
            planName,
            interpolation: { escapeValue: false }
          })}
        </p>
        
        <p className="mb-0">
          {__('dashboard.sections.recurringPayments.subscribers.reactivateSubscriptionModal.billingInfo')}
        </p>
      </div>
    </DashboardModal>
  );
};

